export const getExceptionsByAssignmentIdentifier = (
  assignmentsExceptions,
  assignmentIdentifier
) => {
  if (!assignmentsExceptions || !assignmentIdentifier) return
  return assignmentsExceptions.find((assignment) => assignment.identifier === assignmentIdentifier)
    ?.studentExceptions
}
